/**
 * File: authDashboardController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import newThemePopup from '../views/newThemePopup.html'
class AuthSidenavController {
    // @ngInject
    constructor($scope, $rootScope, $mdSidenav, authService, localStorageService, $state, AUTHSIDENAVCONSTANT, AUTHDASHCONSTANT, $mdDialog, $mdMedia) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            // $rootScope.title = "Courseware"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {
            planIds = []
            resourceIds = []
            authoring = localStorageService.get('authoringData')
            userDetails = []
            url = ""
            userId = ""
            $scope.userAccess = ""
            $scope.menuPlan = ""
        }


        let planIds = []
        let resourceIds = []
        let authoring = localStorageService.get('authoringData')
        let userDetails = []
        let url = AUTHSIDENAVCONSTANT.API_AUTH_SIDENAV_URL
        let userId = localStorageService.get("user_id")
        let schoolId = localStorageService.get("school_id")
        //For toggle sidenav
        var buildToggler = (navID, $mdSidenav) => {
            return function () {
                $mdSidenav(navID)
                    .toggle()
            }
        }
        $rootScope.toggleLeft = buildToggler('left', $mdSidenav)
        $rootScope.isOpenLeft = function () {
            return $mdSidenav('left').isOpen();
        };

        /*
         * Function to set Teaching plan
         * @data: [Object] - theme list 
         * Developer : Arul Mozhi J
        */
        let setTeachingplanList = (data) => {
            _.each(data, function (theme) {
                let planList = [];
                _.each(theme.plans, function (tp) {
                    if ($scope.userAccess) {
                        if ($scope.userAccess.approvedPlans && $scope.userAccess.approvedPlans.read) {
                            if (tp.status === AUTHDASHCONSTANT.STATUS_APPROVED) {
                                if (tp.teacher_id === userId) {
                                    planList.push(tp);
                                }
                                // Display teaching plan to assigned students only
                                if (tp.students && tp.students.length > 0) {
                                    _.each(tp.students, function (student) {
                                        if (student === userId) {
                                            planList.push(tp)
                                        }
                                    })
                                }
                                // Display teaching plan to shared to parents only
                                if (tp.shared_parents && tp.shared_parents.length > 0) {
                                    _.each(tp.shared_parents, function (parent) {
                                        if (parent.parent_id === userId) {
                                            if (planList.findIndex(i => i._id === tp._id) === -1)
                                                planList.push(tp)
                                        }
                                    })
                                }
                            }
                        }
                        if ($scope.userAccess.rejectedPlans && $scope.userAccess.rejectedPlans.read) {
                            if (tp.status === AUTHDASHCONSTANT.STATUS_REJECTED) {
                                if (tp.teacher_id === userId)
                                    planList.push(tp);
                            }
                        }
                        if ($scope.userAccess.newTeachingPlan && $scope.userAccess.newTeachingPlan.read) {
                            if (tp.status === AUTHDASHCONSTANT.STATUS_CREATED || tp.status === AUTHDASHCONSTANT.STATUS_DRAFT) {
                                if (tp.teacher_id === userId)
                                    planList.push(tp);
                            }
                        }
                        if ($scope.userAccess.sentForApprovalPlans && $scope.userAccess.sentForApprovalPlans.read) {
                            if (tp.status === AUTHDASHCONSTANT.STATUS_SENT_FOR_APPROVAL) {
                                if (tp.teacher_id === userId)
                                    planList.push(tp);
                            }
                            if (planIds.indexOf(tp._id) > -1) {
                                if (tp.teacher_id !== userId) {
                                    tp.isToApprove = true;
                                    planList.push(tp);
                                }
                            }
                        }
                    }
                })
                theme.plans = planList;
            })
            $scope.menuPlan = data
            _.defer(() => { $scope.$apply(); })
        }

        /*
         * Function to upadate sidenave 
         * Developer : Arul Mozhi J
        */
        $rootScope.updateSidenav = () => {
            // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
            // let tpSideNavUserAccess = UserPrivilages.getFeatures("teachingPlan");
            let tpSideNavUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
                return feature.module_state == "teachingPlan"
            })
            $scope.userAccess = {};
            if (tpSideNavUserAccess.length > 0) {
                _.each(tpSideNavUserAccess, function (forumObj) {
                    let user_access = {};
                    _.each(forumObj.privilege, function (privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    $scope.userAccess[forumObj.feature_id] = user_access;
                })
            }
            let reportAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
                return feature.module_state == "reports"
            })
            // let reportAccess = UserPrivilages.getFeatures("reports");
            $scope.reportUserAccess = {};
            if (reportAccess.length > 0) {
                _.each(reportAccess, function (forumObj) {
                    let user_access = {};
                    _.each(forumObj.privilege, function (privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    $scope.reportUserAccess[forumObj.feature_id] = user_access;
                })
            }
            if (tpSideNavUserAccess.length > 0) {
                userDetails = localStorageService.get("personData")
                if (userDetails && userDetails.courseware_details) {
                    let coursewareObj = userDetails.courseware_details
                    if (coursewareObj.teaching_plan_approval) {
                        let tp = _.find(coursewareObj.teaching_plan_approval, function (obj) {
                            return (obj.class_id === authoring.class_id) &&
                                (obj.batch_id === authoring.batch_id) &&
                                (obj.session_id === authoring.session_id) &&
                                (obj.subject_id === authoring.subject_id) &&
                                (obj.curriculum_id === authoring.curriculum_id)
                        })
                        if (tp) {
                            planIds = tp.plan_ids
                            resourceIds = tp.resource_ids
                            localStorageService.set("planIds", tp.plan_ids)
                            localStorageService.set("approverResourceIds", resourceIds)
                            localStorageService.set("teachingPlanIdstoApprove", tp.plan_ids_to_approve)
                        }
                    }
                }
                if ($scope.userAccess.newTeachingPlan && $scope.userAccess.newTeachingPlan.create) {
                    $scope.createStatus = true
                }

            }
            let params = {
                curriculum_id: authoring.curriculum_id,
                session_id: authoring.session_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                academic_year: authoring.academic_year
            }
            authService.callAPI(url, 'POST', params, function (response) {
                if (response) {
                    let result = response.result.data;
                    setTeachingplanList(result)
                }
            })
            // })
        }

        $rootScope.updateSidenav()

        /*
         * Function to goto tp create page
         * @module: Object - theme details
         * Developer : Arul Mozhi J
        */
        $scope.gotoCreatePage = (module) => {
            $rootScope.toggleLeft();
            localStorageService.set("plan_details", {
                theme_name: module.name
            } )

            $state.go('newTeachingPlan', {
                "id": module._id,
                "planId": ''
            });
        }

        /*
         * Function to goto plan view
         * @feature: Object - plan details 
         * Developer : Arul Mozhi J
        */
        $scope.gotoViewPage = (feature) => {
            $rootScope.toggleLeft();
             console.log("*************")
            $state.go('viewTeachingPlan', {
                "planId": feature._id

            });
        }

        /*
         * Function to goto overview page
         * Developer : Arul Mozhi J
        */
        $scope.gotoauthoringtool = () => {
            $state.go('authoringTool');
        }

        /*
         * Function to goto courseware 
         * Developer : Arul Mozhi J
        */
        $scope.gotoauthDahBoard = () => {
            $state.go('authdashboard');
        }

        //To collapse all accordian
        $scope.collapseAll = function (accordianData, selectedData, index) {
            _.each(accordianData, function (data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !selectedData.expanded;
            })
        }
        $scope.newThemePopup = function () {
            $rootScope.toggleLeft();
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    localStorageService : localStorageService,
                    authoring : authoring,
                    userId : userId,
                    schoolId : schoolId
                },
                template: newThemePopup,
                controller: ['$scope', '$mdDialog','localStorageService', newThemePopupCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            }).then(function (){
            })
        }
        var newThemePopupCtrl = function ($scope, $mdDialog) {
            $scope.cancel = () => {
                $mdDialog.hide()
            }
                    
        //To save theme
        $scope.saveTheme = () => {
            let themeObject = {
                curriculum_id: authoring.curriculum_id,
                subject_id: authoring.subject_id,
                class_id: authoring.class_id,
                theme_title: $scope.theme_title ? $scope.theme_title.trim() : ""
            }
            let errorCount = validateTheme(themeObject);
            if (errorCount === 0) {
                let params = {
                    curriculum_id: themeObject.curriculum_id,
                    subject_id: themeObject.subject_id,
                    class_id: themeObject.class_id,
                    school_id: schoolId,
                    user_id: userId,
                    theme_title: themeObject.theme_title,
                    id: $scope.theme_id
                }
                authService.callAPI("/v0/archives/themes/save", "POST", params, function(resultObj){
                    let result = resultObj.result.data;
                    if (result.success) {
                        if(result.is_exists){
                            $scope.errors["theme_title"] = "Theme Already exists"
                        }else{
                            toastr.success("Saved successfully")
                            $rootScope.updateSidenav()
                            $mdDialog.hide()

                        }
                    } else {
                        toastr.error("Network Error")
                    }
                    _.defer(function() { $scope.$apply(); });
                })
            }
        }
                
        // To validate theme
         
            var validateTheme = (themeObject) => {
                let errorCount = 0
                $scope.errors = {}
                $scope.errors = {}
                if (themeObject.curriculum_id === undefined || themeObject.curriculum_id === "" || themeObject.curriculum_id === null) {
                    $scope.errors["curriculum"] = "Please select curriculum"
                    $scope.fullScreen = false;
                    errorCount++
                }
                if (themeObject.subject_id === undefined || themeObject.subject_id === "" || themeObject.subject_id === null) {
                    $scope.errors["subject"] = "Please select subject"
                    $scope.fullScreen = false;
                    errorCount++
                }
                if (themeObject.class_id === undefined || themeObject.class_id === "" || themeObject.class_id === null) {
                    $scope.errors["class"] = "Please select class"
                    $scope.fullScreen = false;
                    errorCount++
                }
                if (themeObject.theme_title === undefined || themeObject.theme_title === "" || themeObject.theme_title === null) {
                    $scope.errors["theme_title"] = "Enter Theme Name"
                    errorCount++
                }
                return errorCount;
            }
        }

    }
}

export default AuthSidenavController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/controllers/authSidenavController.js